import { t } from 'i18next';

// Values the voice library API is known to send. The API returns free text, so a value outside
// these lists is shown as it came instead of as a missing translation key.
const CATEGORIES = [
  'premade',
  'cloned',
  'generated',
  'professional',
  'famous',
  'high_quality',
] as const;
const GENDERS = ['male', 'female', 'neutral'] as const;
const AGES = ['young', 'middle_aged', 'old'] as const;

/** Categories the voices page can filter by, in the order of its dropdown. */
export const CATEGORY_FILTERS = ['premade', 'cloned', 'generated'] as const;

const isOneOf = <T extends string>(list: readonly T[], value: string): value is T =>
  (list as readonly string[]).includes(value);

export const categoryLabel = (value: string | null) =>
  value && isOneOf(CATEGORIES, value) ? t(`voices:categories.${value}`) : value;

export const genderLabel = (value: string | null) =>
  value && isOneOf(GENDERS, value) ? t(`voices:gender.${value}`) : value;

export const ageLabel = (value: string | null) =>
  value && isOneOf(AGES, value) ? t(`voices:age.${value}`) : value;
